import { useUserStore } from '@/store/user'
import { useFeatureFlagsStore } from '@/store/feature-flags'
import { createRouter, type RouteRecordRaw, createWebHistory } from 'vue-router'
import { featureRoutes } from '../app/features'

const routes: RouteRecordRaw[] = [...featureRoutes]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async to => {
  const store = useUserStore()
  const isAuthenticated = await store.isAuthenticated
  if (to.meta.auth && !isAuthenticated) return '/login'
  if (!store.hasPermission(to.meta.permission as string)) return '/home'
  // Bloquea el acceso directo por URL a rutas gateadas por feature flag.
  // Solo aplica a rutas que declaran featureFlag/hideWhenFlag en su meta.
  const hasFlagMeta = to.meta.featureFlag || to.meta.hideWhenFlag
  if (hasFlagMeta) {
    const featureFlags = useFeatureFlagsStore()
    if (
      !featureFlags.isVisibleForFlags({
        featureFlag: to.meta.featureFlag as string | undefined,
        hideWhenFlag: to.meta.hideWhenFlag as string | undefined
      })
    ) {
      return '/home'
    }
  }
})

export default router
